import React, { useState, useEffect, useRef } from "react";
import InView from "react-intersection-observer";
import HeaderAnim from '../common/utils/animations/textRevealAnimation';
import { motion, useViewportScroll, useTransform } from 'framer-motion';
import IconGreen from "../../icons/icon-plus-green.svg";
import Counter from '../common/utils/animations/CounterAnim';
import CountUp from "react-countup";
import { SlideInWithScroll } from "../common/utils/animations/slideInWithScroll";
import Parallax from "../common/utils/animations/parallax";
import { directions } from "../common/utils/animations/animationConstants";

const LogoAnim = ({ initial, final, getScrollValue, logo }) => {
  const { scrollY } = useViewportScroll();
  const triggerPoints = [0.45, 0.4, 0.35, 0.3, 0.25, 0.2, 0.15, 0.1, 0.05, 0];
  const opacity = useTransform(scrollY,
    [getScrollValue(triggerPoints[initial]),
    getScrollValue(triggerPoints[final])],
    [0, 1], [0.42, 0, 0.58, 1]);
  return <motion.li
    key={initial}
    style={{ opacity }}
    className="col">
    {logo.icon}
    <img src={logo.image} title={logo.title} alt={logo.alt} />
  </motion.li>;
};

export default function HomePartner(props) {
  const { classes, title, header, content, partnerLogos, companyCounterItems } = props.data;
  const [isVisible, setIsVisible] = useState(false);
  const [counterTrigger, setCounterTrigger] = useState(false);
  const [elementTop, setElementTop] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const { scrollY } = useViewportScroll();
  const easing = [0.42, 0, 0.58, 1];
  const ref = useRef();

  const setValues = () => {
    if (!ref.current) return;

    setElementTop(ref.current.offsetTop);
    setClientHeight(window.innerHeight);
  };

  useEffect(() => {

    setValues();
    document.addEventListener('load', setValues);
    window.addEventListener('resize', setValues);
    return () => {
      document.removeEventListener('load', setValues);
      window.removeEventListener('resize', setValues);
    };
  }, [ref]);

  const getScrollValue = (trigger) => {
    return elementTop - clientHeight * trigger;
  };

  const y = useTransform(scrollY, [getScrollValue(0.5), getScrollValue(0.7)], [0, -20], easing);
  const opacity = useTransform(scrollY, [getScrollValue(0.5), getScrollValue(0.7)], [1, 0], easing);
  const y1 = useTransform(scrollY, [getScrollValue(0.4), getScrollValue(0.6)], [0, -20], easing);
  const opacity1 = useTransform(scrollY, [getScrollValue(0.4), getScrollValue(0.6)], [1, 0], easing);
  //[0.42, 0.37, 0.32, 0.27, 0.22, 0.17, 0.12, 0.07, 0.02, 0];
  const triggers = [[1, 0.9], [0.95, 0.85], [0.9, 0.8], [0.85, 0.75], [1, 0.9], [0.95, 0.85], [0.9, 0.8], [0.85, 0.75]];
  return (
    <InView as="div" onChange={inView => setIsVisible(inView)} className="section-gap" threshold={[0.2]} onLoad={setValues}>
      <div ref={ref} className={"home-partner-section section-gap" + classes}>
        <div className="container">
          <div className="partner-intro-block">
            <p className="theme-color-title">{isVisible && <HeaderAnim header={title} />}</p>
            <Parallax id="partner-intro-block-header" direction={directions.TTB} length={20} triggers={[1, 0.8]} opacity={true}>
              <motion.h3>{header}</motion.h3>
            </Parallax>
            <Parallax id="partner-intro-block-content" direction={directions.TTB} length={20} triggers={[1, 0.8]} opacity={true}>
              <motion.p>{content}</motion.p>
            </Parallax>
          </div>

          <div className="partner-logo-block">
            <ul className="row partner-logo-list d-flex flex-wrap">
              {partnerLogos.map((logo, i) => {
                return <Parallax key={i} id={"partner-logo-" + i} direction={directions.LTR} triggers={triggers[i]} length={25} opacity={true}>
                  <motion.li
                    key={i}
                    className="col">
                    {logo.icon}
                    <img src={logo.image} title={logo.title} alt={logo.alt} />
                  </motion.li>
                </Parallax>;
                /* return <LogoAnim key={i} initial={i} final={8} getScrollValue={getScrollValue} logo={logo} />; */
                /* return <SlideInWithScroll elementTop={elementTop} clientHeight={clientHeight} children={jsx} triggerPoints
                  ={[triggers[i], triggers[i + 2]]} length={25} key={i} />; */
              })}
            </ul>
          </div>
        </div>
      </div>

      <InView as="div" onChange={(inView) => { if (inView) setCounterTrigger(inView); }} className="company-counter-block" threshold={[0.4]}>
        <div className="container">
          <div className="row company-counter-list d-flex flex-wrap">
            {companyCounterItems.map((item, i) => {
              return <div key={i} className="col company-counter-item">
                <div className="item-inner">
                  <div className="item-icon">{item.header}</div>
                  <div className="item-content">
                    <i>{counterTrigger ? <CountUp start={0} end={item.count} duration={1.5} delay={0.3} /> : 0}</i>
                    <i className="icon-plus"><IconGreen /></i>
                    <p>{item.content}</p>
                  </div>
                </div>
              </div>;
            })}
          </div>
        </div>
      </InView>
    </InView >
  );
}

